import { createPermission } from '@backstage/plugin-permission-common';

export const aiGovernanceAccessPermission = createPermission({
  name: 'ai-governance.access',
  attributes: {
    action: 'read',
  },
});

export const aiGovernanceAssessmentEditPermission = createPermission({
  name: 'ai-governance.assessment.edit',
  attributes: {
    action: 'update',
  },
});

export const aiGovernancePermissions = [
  aiGovernanceAccessPermission,
  aiGovernanceAssessmentEditPermission,
];
